export const LOGIN_ACTION = 'LOGIN';
export const LOGOUT_ACTION = 'LOGOUT'